import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'https://myironjournal-backend-gp9bs.ondigitalocean.app/api';

const api = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' }
});

// Attach token to every request
api.interceptors.request.use(config => {
  const token = localStorage.getItem('mij_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Handle 401 globally
api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('mij_token');
      localStorage.removeItem('mij_refresh');
      localStorage.removeItem('mij_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

// ─── Auth ─────────────────────────────────────────────────────────────────────
export const authAPI = {
  login: (username, password) => api.post('/auth/login', { username, password }),
  register: (data) => api.post('/auth/register', data),
  verifyEmail: (email, code) => api.post('/auth/verify-email', { email, code }),
  resendVerification: (email) => api.post('/auth/resend-verification', { email }),
  forgotPassword: (email) => api.post('/auth/forgot-password', { email }),
  resetPassword: (email, code, newPassword) => api.post('/auth/reset-password', { email, code, newPassword }),
};

// ─── User ─────────────────────────────────────────────────────────────────────
export const userAPI = {
  getProfile: () => api.get('/users/me'),
  updateProfile: (data) => api.put('/users/me', data),
  changePassword: (currentPassword, newPassword) => api.put('/users/me/password', { currentPassword, newPassword }),
  exportData: () => api.get('/users/me/export', { responseType: 'blob' }),
  deleteAccount: (password) => api.post('/users/me/delete', { password }),
};

// ─── Daily Logs ───────────────────────────────────────────────────────────────
export const logsAPI = {
  getLogs: (page = 1, limit = 30) => api.get('/daily-logs', { params: { page, limit } }),
  getLogByDate: (date) => api.get(`/daily-logs/date/${date}`),
  saveLog: (log) => api.post('/daily-logs', log),
  deleteLog: (id) => api.delete(`/daily-logs/${id}`),
};

// ─── Trends ───────────────────────────────────────────────────────────────────
export const trendsAPI = {
  getTrends: (period = 'month', start, end) => api.get('/trends', { params: { period, start, end } }),
};

// ─── Exercises ────────────────────────────────────────────────────────────────
export const exercisesAPI = {
  search: (params) => api.get('/exercises/library', { params }),
  getFilters: () => api.get('/exercises/library/meta/filters'),
  getDetail: (id) => api.get(`/exercises/library/${id}`),
  getPlans: () => api.get('/exercises/plans'),
  getPlan: (id) => api.get(`/exercises/plans/${id}`),
  createPlan: (data) => api.post('/exercises/plans', data),
  updatePlan: (id, data) => api.put(`/exercises/plans/${id}`, data),
  deletePlan: (id) => api.delete(`/exercises/plans/${id}`),
  getCalendar: (year, month) => api.get('/exercises/calendar', { params: { year, month } }),
  getTodaysWorkout: () => api.get('/exercises/calendar/today'),
  scheduleWorkout: (data) => api.post('/exercises/calendar', data),
  removeFromCalendar: (date) => api.delete(`/exercises/calendar/${date}`),
  getCustomExercises: (q) => api.get('/exercises/custom', { params: { q } }),
  createCustomExercise: (data) => api.post('/exercises/custom', data),
  updateCustomExercise: (id, data) => api.put(`/exercises/custom/${id}`, data),
  deleteCustomExercise: (id) => api.delete(`/exercises/custom/${id}`),
};

export default api;
